import service from './config.api';

export const TEMPLATES_ENDPOINT = 'configurations/admin/templates';
export const PUBLIC_TEMPLATES_ENDPOINT = 'configurations/templates';

service.getPublicTemplates = async params => {
  const response = await service.get(PUBLIC_TEMPLATES_ENDPOINT, {
    params: params,
  });
  return response.data;
};

service.getTemplates = async params => {
  const response = await service.get(TEMPLATES_ENDPOINT, {
    params: params,
  });
  return response.data.items;
};

export default service;
